import { render, staticRenderFns } from "./Numericpad.vue?vue&type=template&id=1d5bc481&scoped=true&"
import script from "./Numericpad.vue?vue&type=script&lang=js&"
export * from "./Numericpad.vue?vue&type=script&lang=js&"
import style0 from "./Numericpad.vue?vue&type=style&index=0&id=1d5bc481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bc481",
  null
  
)

export default component.exports